import React from 'react'
import PropTypes from 'prop-types'
import { HashLink as Link } from 'react-router-hash-link'

import Button from 'app/components/ButtonDefault'
import HeaderNotification from 'app/domains/common/HeaderNotification'
import PushSubscribeButton from 'app/domains/common/PushSubscribeButton'

import './styles.scss'
export const bc = 'header-notification'

const Notification = ({
  t,
  isTopNotificationBlockShown,
  isShowFeatureSms,
  isDesktopNotificationsAvailable,
  setTopNotificationBlockShown,
  setFeatureAsShown,
}) => {
  if (isTopNotificationBlockShown && isShowFeatureSms) {
    return (
      <HeaderNotification additionalClosingAction={() => setTopNotificationBlockShown(false)}>
        <span className={`${bc}__text`}>
          {t('Did you know you can add your mobile number and receive daily activities as a text message?')}
        </span>
        <Link
          smooth
          to="/profile/notifications#notificationtype"
          className={`${bc}__link`}
          onClick={() => setFeatureAsShown({ sms: false })}
          replace
        >
          {t('Show me')}
        </Link>
        <Button primary sm onClick={() => setFeatureAsShown({ sms: false })} className={`${bc}__button`}>
          {t('No, thanks')}
        </Button>
      </HeaderNotification>
    )
  } else if (isTopNotificationBlockShown && isDesktopNotificationsAvailable) {
    return (
      <HeaderNotification>
        <span className={`${bc}__text`}>{t('Want to be notified via the browser notifications? Click enable')}</span>
        <PushSubscribeButton />
      </HeaderNotification>
    )
  } else {
    return null
  }
}

Notification.propTypes = {
  setTopNotificationBlockShown: PropTypes.func.isRequired,
}

export default Notification
